import React from "react";

import { ReportIndicator } from "@common/reportIndicator";
import { HorizontalList } from "@common/horizontalList";
import { ProjectReport, ReportIndicators } from "@planzone/dto";
import { Props } from "./types";
import styles from "./styles.scss";

function incrementIndicator(
  indicator: ProjectReport["fields"][number],
): ReportIndicators {
  const incrementMap = {
    [ReportIndicators.VERY_GOOD]: ReportIndicators.VERY_BAD,
    [ReportIndicators.GOOD]: ReportIndicators.VERY_GOOD,
    [ReportIndicators.MILD]: ReportIndicators.GOOD,
    [ReportIndicators.BAD]: ReportIndicators.MILD,
    [ReportIndicators.VERY_BAD]: ReportIndicators.BAD,
  };

  return (
    incrementMap[indicator.value as ReportIndicators] || ReportIndicators.GOOD
  );
}

function IndicatorsForm({ indicators, editIndicators }: Props) {
  return (
    <HorizontalList>
      <div className={styles.indicatorsForm}>
        {[...indicators]
          .sort((a, b) => (a.order < b.order ? -1 : 1))
          .map((indicator, index, indicators) => (
            <div
              className={styles.input}
              onClick={() =>
                editIndicators([
                  ...indicators.slice(0, index),
                  {
                    ...indicator,
                    value: incrementIndicator(indicator),
                  },
                  ...indicators.slice(index + 1),
                ])
              }
            >
              <ReportIndicator
                className={styles.indicator}
                value={indicator.value as ReportIndicators}
              />
              <p className={styles.name}>{indicator.name}</p>
            </div>
          ))}
      </div>
    </HorizontalList>
  );
}

export { IndicatorsForm };
